// extracted by mini-css-extract-plugin
export default {"container":"styles_container__S8irv","allowOverlay":"styles_allowOverlay__4SN5N"};